import { fetchApi } from '../api/digitalVault';
import { parsePagination, parsePlaylistItems } from '../utils';
const getUserPlaylistItems = async (id, params = {}, logger) => {
    const rawResponse = await fetchApi(params, `playlist/${id}/list`, {}, false, logger);
    const { hasNextPage, nextPageParams } = parsePagination(rawResponse.playlist.link);
    return {
        hasNextPage,
        data: parsePlaylistItems(rawResponse),
        paginate() {
            return hasNextPage && getUserPlaylistItems(id, nextPageParams, logger);
        },
    };
};
export default getUserPlaylistItems;
